import { Flex, Skeleton, Stack, Text, TextInput } from "@mantine/core";
import { type JSX, useCallback } from "react";
import { useSessionSummaryStore } from "../store/useSessionSummaryStore";

interface SessionSubjectProps {
    loading: boolean;
}

export function SessionSummarySubject({ loading }: SessionSubjectProps): JSX.Element | null {
    const { subject, setSubject, submitted, autogeneratedSummary } = useSessionSummaryStore();

    const handleChange = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {
            setSubject(event.target.value);
        },
        [setSubject],
    );

    return (
        <Stack gap={0} mb="md">
            <Text size="xs" mb=".5rem">
                Subject
            </Text>
            {loading ? (
                <Flex direction="column" align="center" h="40">
                    <Skeleton mb="xxs" h="100%" />
                </Flex>
            ) : (
                <TextInput
                    styles={{
                        input: {
                            fontSize: "var(--mantine-font-size-xs)",
                        },
                    }}
                    value={subject}
                    disabled={submitted || !!autogeneratedSummary}
                    onChange={handleChange}
                    placeholder="Enter subject"
                />
            )}
        </Stack>
    );
}
